import { Tab, Tooltip } from "@mui/material";

export default function TooltipTab(props) {
    return (
        <Tooltip arrow title={props.tooltip}>
            <Tab {...props} />
        </Tooltip>
    );
};